var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUbicacion = function SvgUbicacion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ubicacion_svg__Capa_2",
    viewBox: "0 0 20.55 24.66"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ubicacion_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 10.28c0-5.27-4.26-9.53-9.52-9.53S.75 5.01.75 10.28s9.53 13.4 9.53 13.4 9.53-8.14 9.53-13.4Z",
    fill: "none",
    stroke: "#22aa9e",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.28,
    cy: 9.94,
    r: 2.85,
    fill: "#22aa9e"
  }))));
};
export default SvgUbicacion;